import { Capacitor } from "@capacitor/core";
import {
  AdMob,
  BannerAdPosition,
  BannerAdSize,
  type BannerAdOptions,
} from "@capacitor-community/admob";

/** Google 公式のテスト用バナー広告ユニット */
const TEST_BANNER_ANDROID = "ca-app-pub-3940256099942544/6300978111";
const TEST_BANNER_IOS = "ca-app-pub-3940256099942544/2934735716";

let initialized = false;

export function isAdMobAvailable(): boolean {
  return Capacitor.isNativePlatform();
}

function shouldUseTestAds(): boolean {
  return import.meta.env.VITE_ADMOB_USE_TEST_ADS === "true";
}

/** アプリ起動時に1回（ネイティブのみ） */
export async function initAdMob(): Promise<void> {
  if (!isAdMobAvailable() || initialized) return;
  try {
    await AdMob.initialize({
      initializeForTesting: shouldUseTestAds(),
    });
    initialized = true;
  } catch (e) {
    console.warn("[AdMob] initialize failed", e);
  }
}

export function resolveBannerAdUnitId(): string {
  const custom = (import.meta.env.VITE_ADMOB_BANNER_ID ?? "").trim();
  if (custom) return custom;
  if (shouldUseTestAds()) {
    return Capacitor.getPlatform() === "ios" ? TEST_BANNER_IOS : TEST_BANNER_ANDROID;
  }
  return "";
}

/**
 * メインシェル表示中に画面下部にバナー（タブバーより上に margin で逃がす）
 */
export async function showMainShellBanner(): Promise<void> {
  if (!isAdMobAvailable()) return;
  await initAdMob();
  const adId = resolveBannerAdUnitId();
  if (!adId) return;
  try {
    const options: BannerAdOptions = {
      adId,
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position: BannerAdPosition.BOTTOM_CENTER,
      margin: 88,
      isTesting: shouldUseTestAds(),
    };
    await AdMob.showBanner(options);
  } catch (e) {
    console.warn("[AdMob] showBanner failed", e);
  }
}

export async function removeMainShellBanner(): Promise<void> {
  if (!isAdMobAvailable()) return;
  try {
    await AdMob.removeBanner();
  } catch {
    /* ignore */
  }
}
